import { setInteractionMode, extend } from 'vee-validate';
import { required, email, min, max, confirmed } from 'vee-validate/dist/rules';
// @ts-expect-error TODO
import en from 'vee-validate/dist/locale/en.json';

setInteractionMode('eager');

extend('required', { ...required, message: 'Required' });
extend('email', { ...email, message: en.messages.email });
extend('min', { ...min, message: en.messages.min });
extend('max', { ...max, message: en.messages.max });
extend('confirmed', { ...confirmed, message: en.messages.confirmed });
